import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../../AppContext";
import "./Account.css";
import beOneBlackIcon from "../../../assets/beOneBlackIcon";
import LoginPanel from "./LoginPanel/LoginPanel";

import {
  logActivity,
  getUserId,
  sendTextNotification,
  updateUserSettings,
  getTeamMemberId,
} from "../../utils";
import { TransferToMoveContext } from "./TransferToMove/TransferToMoveContext";
import TransferToMove from "./TransferToMove/TransferToMoveModal";
import { appVersion } from "../../../appVersion";
import dropdownSvg from "../../../assets/dropdownSvg";
import dropupSvg from "../../../assets/dropupSvg";
import PipelineButtons from "../../Pipeline/PipelineButtons";
import LendingTools from "../LendingTools/LendingTools";
import { LendingToolsContext } from "../LendingTools/LendingToolsContext";
import sandovalTeamIcon from "../../../assets/sandovalTeamIcon";
import FilterModal from "../Clients/ClientModals/FilterModal";
import BuyersGuideModal from "../BeOneTeam/BuyersGuideModal";
import { BuyersGuideModalContext } from "../BeOneTeam/BuyersGuideModalContext";

const Account = ({}) => {
  const {
    userEmail,
    userId,
    setUserId,
    userName,
    userPassword,
    userCompany,
    userType,
    setPath,
    windowWidth,
    clientSelection,
    setClientSelection,
    setWorkshopMaterials,
    makeKey,
    movePassword,
    setPreApprovedListModalVisible,
    setUCCListModalVisible,
    textNotifications,
    setTextNotifications,
    appMode,
    setAppMode,
    setModal,
    setLoginModalInputs,
    setLoginModalAction,
    setMatrixData,
    setNavbar,
    setMidbar,
    setUserCompany,
    setUserCompanyId,
    setUserPassword,
    setUserName,
    setMakeKey,
    setUserEmail,
    userPhone,
    setFubId,
    navigate,
    setTeamPermissions,
    setTeamMemberSelected,
    setTeamMemberSelectedInfo,
    setUserPhone,
    fubKey,
    setFubKey,
    teamPermissions,
    teamMemberSelected,
    setTeamFilter,
    teamArray,
    setTeamOptions,
    teamOptions,
    teamFilter,
    path,
    buyersGuide,
    setBuyersGuide,
    setBuyersGuideEditable,
  } = useContext(AppContext);

  const [transferToMoveVisible, setTransferToMoveVisible] = useState(false);
  const [buyersGuideVisible, setBuyersGuideVisible] = useState(false);
  const [accountDetails, setAccountDetails] = useState(false);
  const [faqs, setFaqs] = useState(false);
  const [lendingToolsVisible, setLendingToolsVisible] =
    useState("fullScreen down");

  const loginPage = (
    <div className="Login-container">
      <LoginPanel panelType="Agent" />
      <LoginPanel panelType="Loan Officer" />
    </div>
  );

  const resources = (
    <>
      {userCompany == "Be1 Team" || userCompany == "Move Mortgage" ? (
        <>
          <div
            className="panel"
            onClick={() => {
              setWorkshopMaterials("fullScreen");
              logActivity({
                apiKey: makeKey,
                userEmail: userEmail,
                userType: userType,
                action: "Be1 Workshop Materials",
                tab: "Account",
                userCompany: userCompany,
              });
            }}
          >
            {beOneBlackIcon} The Play 💪
          </div>
          <div
            className="panel"
            onClick={() => {
              window.open(
                "https://docs.google.com/spreadsheets/d/1C2xfiwVaTLCCefi7DQzLrCtGEVWRfasr8ZQlv5wunIY/edit?usp=sharing",
                "_blank"
              );
              logActivity({
                apiKey: makeKey,
                userEmail: userEmail,
                userType: userType,
                action: "Be1 Team Workbook",
                tab: "Account",
                userCompany: userCompany,
              });
            }}
          >
            {beOneBlackIcon} Team Workbook 📒
          </div>
        </>
      ) : null}
      {userCompany == "Sandoval Team" ? (
        <>
          <div
            className="panel"
            onClick={() => {
              setWorkshopMaterials("fullScreen");
              logActivity({
                apiKey: makeKey,
                userEmail: userEmail,
                userType: userType,
                action: "Sandoval Team Play",
                tab: "Account",
                userCompany: userCompany,
              });
            }}
          >
            {sandovalTeamIcon}
          </div>
        </>
      ) : null}
      <div
        className="panel moveMaterials"
        onClick={() => {
          setLendingToolsVisible("fullScreen");
        }}
      >
        Lending Tools
      </div>
    </>
  );

  const accountInfopage = (
    <>
      <div className="account-title">
        Quick <b>Actions</b>
      </div>
      {fubKey ? (
        <div
          className="panel"
          onClick={() => {
            setTransferToMoveVisible(true);
            logActivity({
              apiKey: makeKey,
              userEmail: userEmail,
              userType: userType,
              action: "Transfer to Move Button",
              tab: "Account",
              userCompany: userCompany,
            });
          }}
        >
          Transfer to Move
        </div>
      ) : null}
      <div
        className="panel"
        onClick={() => {
          setPreApprovedListModalVisible("");
          logActivity({
            apiKey: makeKey,
            userEmail: userEmail,
            userType: userType,
            action: "Generate Pre Approval letter Button",
            tab: "Account",
            userCompany: userCompany,
          });
        }}
      >
        Generate a <b>&nbsp;Pre-Approval&nbsp;</b> letter
      </div>
      {userCompany == "Be1 Team" ? (
        <div
          className="panel"
          onClick={() => {
            // setUCCListModalVisible("");
            window.open("https://be1app.netlify.app/transactions/ucc");
            logActivity({
              apiKey: makeKey,
              userEmail: userEmail,
              userType: userType,
              action: "Submit Under Contract Checklist Button",
              tab: "Account",
              userCompany: userCompany,
            });
          }}
        >
          <b>Under Contract</b>&nbsp;Checklist
        </div>
      ) : null}
      {userCompany == "Be1 Team" ? (
        <div
          className="panel"
          onClick={() => {
            const response = window.confirm(
              "Would you like to open the Reimbursement Request form?"
            );
            logActivity({
              apiKey: makeKey,
              userEmail: userEmail,
              userType: userType,
              action: "Reimbursement Request",
              tab: "Account",
              userCompany: userCompany,
            });
            if (response) {
              window.open(
                "https://docs.google.com/forms/d/e/1FAIpQLSdlO1eMkqZa-X9PwLXNmEI5Z7PKbNHbdDpTDPfXpwUTb5BsGA/viewform",
                "_blank"
              );
            }
          }}
        >
          <b>Reimbursement&nbsp;</b>Request
        </div>
      ) : null}
      {userCompany == "Be1 Team" ? (
        <div className="account-panel inlay">
          <span className="colorWhite">LISTINGS</span>
          <div className="tenPx"></div>
          <div
            className="panel inlay"
            onClick={() => {
              const response = window.confirm(
                "Click OK to proceed to open house checklist to generate a QR code."
              );
              logActivity({
                apiKey: makeKey,
                userEmail: userEmail,
                userType: userType,
                action: "Open House Checklist",
                tab: "Account",
                userCompany: userCompany,
              });
              if (response) {
                window.open(
                  "https://docs.google.com/forms/d/e/1FAIpQLSf_r0ulvQou6yivz27HBEpqDULISFWSMv9OZlVEzrojQajHIg/viewform?usp=sf_link",
                  "_blank"
                );
              }
            }}
          >
            <span className="new-banner">NEW</span>Create
            <b>&nbsp;QR Code</b>
          </div>
          <div
            className="panel inlay"
            onClick={() => {
              const response = window.confirm(
                "Click OK to proceed to open house sign reservation form."
              );
              logActivity({
                apiKey: makeKey,
                userEmail: userEmail,
                userType: userType,
                action: "Open House Sign Reservation",
                tab: "Account",
                userCompany: userCompany,
              });
              if (response) {
                window.open(
                  "https://docs.google.com/forms/d/e/1FAIpQLScgTxKlY0gU7ssB_XBInNYq3xM7A5_cjCy15rL1LTe4CfAoSQ/viewform",
                  "_blank"
                );
              }
            }}
          >
            Reserve<b>&nbsp;Open House Signs</b>
          </div>
        </div>
      ) : null}
      {userCompany == "Be1 Team" && buyersGuide ? (
        <div
          className="panel"
          onClick={() => {
            logActivity({
              apiKey: makeKey,
              userEmail: userEmail,
              userType: userType,
              action: "Share your Buyer's Guide",
              tab: "Account",
              userCompany: userCompany,
            });
            setBuyersGuideVisible(true);
          }}
        >
          Share Your <b>&nbsp;Buyer's Guide&nbsp;</b> 📖
        </div>
      ) : null}
      {windowWidth < 750 ? <PipelineButtons /> : null}
      <div className="account-title">
        <b>Resources</b>
      </div>
      {resources}
      <div className="twentyFivePx"></div>
      <div className="dotted-hr white"></div>
      <div
        className="account-title account-details"
        onClick={() => {
          accountDetails ? setAccountDetails(false) : setAccountDetails(true);
        }}
      >
        <b>Account</b>
        {accountDetails ? dropupSvg : dropdownSvg}
      </div>
      <div
        className={`account-panel nohover ${accountDetails ? null : "hidden"}`}
      >
        <div className="fullWidth">
          <div className="textAlignCenter nameText">{userName}</div>
          <div className="textAlignCenter versionText">
            Version {appVersion}
          </div>
          <div className="tenPx"></div>
        </div>
        <div className="spaceBetween sidePaddingTwenty">
          <div>Text Alerts</div>
          <div
            className={`toggle ${textNotifications}`}
            onClick={() => {
              if (!textNotifications) {
                updateUserSettings({
                  apiKey: makeKey,
                  userType: userType,
                  userId: userId,
                  field: "Text Notification",
                  value: true,
                });
                sendTextNotification({
                  textNotificationsAllowed: true,
                  textMessage: `Move Matrix | You have opted in to receiving text alerts from Move Matrix.\n\nReply 'STOP' at anytime to unsubscribe or disable text notifications in: https://movematrix.netlify.app/`,
                  textPhone: userPhone,
                });
                setTextNotifications(true);
                alert(
                  `You will now receive text notifications to ${userPhone}`
                );
              } else {
                updateUserSettings({
                  apiKey: makeKey,
                  userType: userType,
                  userId: userId,
                  field: "Text Notification",
                  value: false,
                });
                setTextNotifications(false);
                alert(
                  `You have disabled text notifications. If this was done by error, click the toggle next to "Text Alerts" to receive text notifications.`
                );
              }
              logActivity({
                apiKey: makeKey,
                userEmail: userEmail,
                userType: userType,
                action: textNotifications
                  ? `Turn off text notifications`
                  : `Turn on text notifications`,
                tab: "Account",
                userCompany: userCompany,
              });
            }}
          >
            <div className="option"></div>
          </div>
        </div>
        <div className="sidePaddingTwenty smallText textAlignLeft">
          {textNotifications ? (
            <i>
              You are receiving text alerts to {userPhone}. Toggle off to
              disable text alerts.
            </i>
          ) : (
            <i>
              To receive text alerts to {userPhone}, turn toggle on. If you are
              still not receiving alerts, text 'START' to 720-730-8096.
            </i>
          )}
        </div>
        <div className="tenPx"></div>
        <div className="panel nohover" id="app-mode">
          <div>App Mode</div>
          <div
            className={`toggle ${appMode}`}
            onClick={() => {
              appMode == "on" ? setAppMode("off") : setAppMode("on");
              logActivity({
                apiKey: makeKey,
                userEmail: userEmail,
                userType: userType,
                action: "Toggle App Mode",
                tab: "Account",
                userCompany: userCompany,
              });
            }}
          >
            <div className="option"></div>
          </div>
        </div>
        <div className="Account-buttons">
          <div
            className="button"
            onClick={() => {
              getUserId({
                setUserId: setUserId,
                userEmail: userEmail,
                userType: userType,
                makeKey: makeKey,
                userPassword: userPassword,
                movePassword: movePassword,
                setUserPhone: setUserPhone,
                setLoginModalInputs: setLoginModalInputs,
                setMatrixData: setMatrixData,
                setLoginModalAction: setLoginModalAction,
                setModal: setModal,
                setNavbar: setNavbar,
                setMidbar: setMidbar,
                setUserEmail: setUserEmail,
                setUserCompany: setUserCompany,
                setUserCompanyId: setUserCompanyId,
                setTextNotifications: setTextNotifications,
                setUserPassword: setUserPassword,
                setUserName: setUserName,
                setMakeKey: setMakeKey,
                setPath: setPath,
                path: path,
                setFubId: setFubId,
                navigate: navigate,
                clientSelection: clientSelection,
                setClientSelection: setClientSelection,
                action: "Refresh",
                actionTab: "Account",
                setTeamPermissions: setTeamPermissions,
                setTeamMemberSelected: setTeamMemberSelected,
                setTeamMemberSelectedInfo: setTeamMemberSelectedInfo,
                setFubKey: setFubKey,
                setBuyersGuide: setBuyersGuide,
                setBuyersGuideEditable: setBuyersGuideEditable,
              });
              setLoginModalInputs([
                ["loadingData", "Loading your data...", "none"],
              ]);
              setModal("active");
            }}
          >
            <b>Refresh</b>
          </div>
          <div
            className="button"
            onClick={() => {
              const requestLogout = window.confirm(
                "Are you sure you would like to logout?"
              );
              if (requestLogout) {
                localStorage.clear();
                window.location.reload();
              }
            }}
          >
            <b>Logout</b>
          </div>
          <a
            className="blueLink"
            href="https://forms.gle/PD2udmyjtDk7npc68"
            target="_blank"
          >
            Submit feedback
          </a>
        </div>
      </div>
    </>
  );

  const howTos = (
    <>
      <div
        className="account-title account-details"
        onClick={() => {
          faqs ? setFaqs(false) : setFaqs(true);
        }}
      >
        <b>iPhone Download</b>
        {faqs ? dropupSvg : dropdownSvg}
      </div>
      <div className={`faqs ${faqs ? null : "hidden"}`}>
        <iframe
          className="youtube-video"
          src="https://www.youtube.com/embed/BcKixxJk8tg"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
    </>
  );

  //Team Filter Modal Functions
  const [searchTeam, setSearchTeam] = useState("");

  let defaultOption = <></>;
  if (teamPermissions) {
    defaultOption = (
      <div>
        <li
          className={`ClientRow ${
            teamMemberSelected == userName ? "grey" : null
          }`}
          onClick={() => {
            setTeamFilter("hidden");
            if (teamMemberSelected !== userName) {
              getTeamMemberId({
                userType: userType,
                userCompany: userCompany,
                makeKey: makeKey,
                setLoginModalInputs: setLoginModalInputs,
                setMatrixData: setMatrixData,
                setLoginModalAction: setLoginModalAction,
                setModal: setModal,
                setNavbar: setNavbar,
                setMidbar: setMidbar,
                setMakeKey: setMakeKey,
                setFubId: setFubId,
                userEmail: userEmail,
                teamMemberSelected: userName,
                setTeamMemberSelected: setTeamMemberSelected,
                setTeamMemberSelectedInfo: setTeamMemberSelectedInfo,
                tab: "Pre-Approvals",
              });
            }
            setTeamMemberSelected(userName);
          }}
        >
          <div className="name">{userName}</div>
        </li>
        <div className="tenPx"></div>
        <div className="dotted-hr"></div>
        <div className="spaceBetween">
          <input
            className="searchInput"
            placeholder="Search"
            onChange={(e) => {
              setSearchTeam(e.target.value);
            }}
          ></input>
        </div>
      </div>
    );
  }

  useEffect(() => {
    const formattedArray = teamArray
      .filter((e) => {
        return e["Name"].toLowerCase().includes(searchTeam.toLowerCase());
      })
      .sort((a, b) => {
        if (a["Name"] > b["Name"]) {
          return 1;
        } else {
          return -1;
        }
      })
      .map((e) => {
        if (teamMemberSelected == e["Name"]) {
          return (
            <li
              className="ClientRow grey"
              onClick={() => {
                setTeamFilter("hidden");
              }}
              key={Math.random()}
            >
              <div className="name">{e["Name"]}</div>
            </li>
          );
        } else if (teamArray[0]["Name"] == "Loading team...") {
          return (
            <div key={Math.random()} className="name">
              Loading your team...
            </div>
          );
        } else {
          return (
            <li
              className="ClientRow"
              onClick={() => {
                setTeamFilter("hidden");
                setTeamMemberSelected(e["Name"]);
                getTeamMemberId({
                  userType: userType,
                  userCompany: userCompany,
                  makeKey: makeKey,
                  setLoginModalInputs: setLoginModalInputs,
                  setMatrixData: setMatrixData,
                  setLoginModalAction: setLoginModalAction,
                  setModal: setModal,
                  setNavbar: setNavbar,
                  setMidbar: setMidbar,
                  setMakeKey: setMakeKey,
                  setFubId: setFubId,
                  userEmail: userEmail,
                  teamMemberSelected: e["Name"],
                  setTeamMemberSelected: setTeamMemberSelected,
                  setTeamMemberSelectedInfo: setTeamMemberSelectedInfo,
                  tab: "Pre-Approvals",
                });
              }}
              key={Math.random()}
            >
              <div className="name">{e["Name"]}</div>
            </li>
          );
        }
      });
    setTeamOptions(<div>{formattedArray}</div>);
  }, [teamArray, searchTeam, teamMemberSelected]);

  return (
    <div className={`Account`}>
      <div className="Login">
        {userEmail ? accountInfopage : loginPage}

        {howTos}
        <div className="oneHundredPx"></div>
      </div>
      <TransferToMoveContext.Provider
        value={{
          transferToMoveVisible,
          setTransferToMoveVisible,
        }}
      >
        <TransferToMove formId={"transferToMoveForm"} />
      </TransferToMoveContext.Provider>
      <BuyersGuideModalContext.Provider
        value={{
          buyersGuideVisible,
          setBuyersGuideVisible,
        }}
      >
        <BuyersGuideModal />
      </BuyersGuideModalContext.Provider>
      <LendingToolsContext.Provider
        value={{ lendingToolsVisible, setLendingToolsVisible }}
      >
        <LendingTools />
      </LendingToolsContext.Provider>
      <FilterModal
        options={teamOptions}
        visible={teamFilter}
        setFilter={setTeamFilter}
        defaultOption={defaultOption}
      />
    </div>
  );
};

export default Account;
